import { Injectable, Optional } from '@angular/core';

export class AuthConfigServiceOption {
  options?: any;
  routingBaseUri?: string;
  accountCreation?: boolean;
  themingClassName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthConfigService {
  private _options = null;
  private _routingBaseUri = '';
  private _accountCreation = false;
  private _themingClassName = '';

  public get routingBaseUri(): string {
    return this._routingBaseUri.toString();
  }
  public set routingBaseUri(value: string) {
    this._routingBaseUri = value;
  }
  public get themingClassName(): string {
    return this._themingClassName;
  }

  constructor(@Optional() config: AuthConfigServiceOption) {
    if (config) {
      this._options = config.options;
      this._routingBaseUri = config.routingBaseUri || '';
      this._accountCreation = !!config.accountCreation;
      this._themingClassName = config.themingClassName || '';
    }
  }

  setOptions(value) {
    this._options = value;
  }

  getOptions() {
    return this._options;
  }

  isCreationAuthorized(): boolean {
    return this._accountCreation;
  }
}
